import { render, staticRenderFns } from "./SupplierRawMaterialDietarySuitability.vue?vue&type=template&id=2608672a&scoped=true&"
import script from "./SupplierRawMaterialDietarySuitability.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialDietarySuitability.vue?vue&type=script&lang=js&"
import style0 from "./SupplierRawMaterialDietarySuitability.vue?vue&type=style&index=0&id=2608672a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608672a",
  null
  
)

export default component.exports